module.exports = __webpack_public_path__ + "assets/img/thumb-Kent-Street-Cellars-1-Video.be6c8da9.jpg";